import React from 'react';
import PropTypes from 'prop-types';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';
import { strings } from 'APP_ROOT/localization';
import eventMediaImagePlay from 'APP_ROOT/components/pages/dashboard/EventMedia/images/play-w64.svg';
import { EVENT_MEDIA_REQUEST_TYPE } from  'APP_ROOT/components/pages/dashboard/EventMedia/eventMediaConstants';

export class EventItemMediaIcon extends React.PureComponent {

    rav1049RefreshTimestampTimeoutId = null;

    constructor(props) {
        super(props);

        this.state = {
            rav1049RefreshTimestamp : null
        }
    }
    componentWillUnmount() {
        if (this.rav1049RefreshTimestampTimeoutId) clearTimeout(this.rav1049RefreshTimestampTimeoutId);
    }

    getMediaArrayForRawEvent = (event) => {  //TODO remove by moving to the redux store

        var mediaArray = [];

        if (!this.props.allSupportedEvents) {
            console.warn("Dashboard eventScrollableList getMediaArrayForRawEvent allSupportedEvents is nil.  Returning empty array.");
            return mediaArray;
        }

        for (var i in this.props.allSupportedEvents) {
            if (this.props.allSupportedEvents[i].ts === event.ts) {
                if (this.props.allSupportedEvents[i].type === event.type) {
                    mediaArray.push(this.props.allSupportedEvents[i].media);
                }
            }
        }
        return mediaArray;
    }

    eventHasShortOrShortPreview = (event) => {

        if (!event) {
            return false;
        }

        const mediaList = this.getMediaArrayForRawEvent(event);

        if (!mediaList) {
            console.warn("Dashboard eventScrollableList eventHasShortOrShortPreview invalid media array property for rawEvent from allSupportedEvents for event matching ts and type (" + event.ts + ", " + event.type + ").  Returning false.");
            return false;
        }
        
        return mediaList.find(media => {
            if (media && media.type === "MEDIA_PREVIEW_VIDEO") {
                return true;
            }
            if (media && media.type === "MEDIA_SHORT") {
                if (media.availableOnRaven === true) {
                    return true;
                }
            }
            return false;
        });
    }

    eventHasCloudVideoClip = (event) => {

        const mediaList = this.getMediaArrayForRawEvent(event);
        const videoClipSource = mediaList.find(media => {
            if (media && media.type === "MEDIA_PREVIEW_VIDEO") {
                return true;
            }
            if (media && media.type === "MEDIA_STREAMING_ARCHIVE") {
                return true;
            }
        });
        return videoClipSource ? true : false;
    }

    eventHasVideoAvailable = (event) => {

        // RAV-1049 - events that are <60 seconds old probably do not have video yet
        // IMPORTANT - there is a corresponding RAV-1049 patch in EventMedia.js
        const eventDate = new Date(RavenUtil.convertTs(event.ts));
        let millisecondsAgo = Date.now() - eventDate;
        let rav1049RefreshTimestampTimeout = 60000; // 60 seconds
        if (millisecondsAgo < 0) {
            rav1049RefreshTimestampTimeout += Math.abs(millisecondsAgo);
            millisecondsAgo = 0; // consider this a current event
        }
        if (Math.round(millisecondsAgo/1000) <= 60) {
            rav1049RefreshTimestampTimeout -= millisecondsAgo - 1000; // 60+1 seconds from the event's timestamp (adding 1 second to ensure above condition passes)
            if (this.rav1049RefreshTimestampTimeoutId) clearTimeout(this.rav1049RefreshTimestampTimeoutId);
            this.rav1049RefreshTimestampTimeoutId = setTimeout(() => {
                this.setState({
                    rav1049RefreshTimestamp: Math.round(new Date().getTime()/1000)
                });
            }, rav1049RefreshTimestampTimeout);
            return false;
        }

        let eventHasVideoAvailable = this.eventHasShortOrShortPreview(event);
        const eventVideoAvailable = event.videoAvailable;
        if (!eventVideoAvailable) {
            console.warn("EventItem eventHasVideoAvailable with event missing videoAvailable property");
            return eventHasVideoAvailable;
        }
        if (eventVideoAvailable.road || eventVideoAvailable.cabin) {
            eventHasVideoAvailable = true;
        }
        return eventHasVideoAvailable;
    }

    render() {

        var iconForEventHasVideo = null;
        if (this.props.mediaRequestType === EVENT_MEDIA_REQUEST_TYPE.USER_MEDIA_REQUEST) {
            if (this.eventHasVideoAvailable(this.props.event)) {
                let className = "media-badge";
                let title = strings.title_media_video_clip_available_on_raven;
                if (this.eventHasCloudVideoClip(this.props.event)) {
                    className = className + " video-clip-uploaded";
                    title = strings.title_media_has_video_clip;
                }
                iconForEventHasVideo = (<img alt='Play' src={eventMediaImagePlay} className={className} title={title} />);
            }
        } else if (this.props.mediaRequestType === EVENT_MEDIA_REQUEST_TYPE.VIDEO_PREVIEW_REQUEST) {
            if (this.eventHasShortOrShortPreview(this.props.event)) { // DEPRECATED_VIDEO_PREVIEW_REQUEST
                iconForEventHasVideo = (<img src={eventMediaImagePlay} className="media-badge" />);
            }
        }

        return (
            <>
                {iconForEventHasVideo}
            </>
        );
    }
}

EventItemMediaIcon.propTypes = {
    event: PropTypes.object.isRequired,
    mediaRequestType: PropTypes.string.isRequired,
    allSupportedEvents: PropTypes.array.isRequired
};